import styled from "styled-components";
import { motion } from "framer-motion";
import {
  AiFillLinkedin,
  AiOutlineTwitter,
  AiOutlineGithub,
} from "react-icons/ai";
import { FaEnvelope } from "react-icons/fa";
import { letterAnimation } from "../animation";

const Footer = () => {
  const time = new Date();
  const hour = time.getHours();
  const nHour = hour - 12;
  const minute = time.getMinutes();
  return (
    <StyledFooter>
      <Container>
        <motion.div
          initial="hide"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ staggerChildren: 0.1 }}
          className="links"
        >
          <motion.span variants={letterAnimation}>
            <a
              href="http://www.linkedin.com/in/iretomiwa-kehinde-abajo-46898a197"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiFillLinkedin size="1.5rem" />
            </a>
          </motion.span>
          <motion.span variants={letterAnimation}>
            <a
              href="http://twitter.com/IRE_TOMS"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiOutlineTwitter size="1.5rem" />
            </a>
          </motion.span>
          <motion.span variants={letterAnimation}>
            <a
              href="http://www.github.com/Iretoms"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiOutlineGithub size="1.5rem" />
            </a>
          </motion.span>
          <motion.span variants={letterAnimation}>
            <a
              href="mailto:iretomiwajonathan@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEnvelope size="1.5rem" />
            </a>
          </motion.span>
        </motion.div>
        <motion.div
          initial="hide"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ staggerChildren: 0.1 }}
          className="time"
        >
          <motion.span variants={letterAnimation}>
            {hour > 12 ? nHour : hour}:{minute < 10 ? `0${minute}` : minute}{" "}
            {hour >= 12 ? "PM" : "AM"}
          </motion.span>
        </motion.div>
      </Container>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  width: 100%;
  min-height: 15vh;
`;

const Container = styled.div`
  padding-top: 3rem;
  width: 85%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  span {
    display: inline-block;
  }
  .links {
    overflow: hidden;
    span {
      margin-right: 1.5rem;
    }
  }
  .time {
    overflow: hidden;
    span {
      font-weight: bold;
    }
  }

  @media screen and (max-width: 600px) {
    padding-top: 0.5rem;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;

export default Footer;
